export const useStore = () => {
  const user = JSON.parse(localStorage.getItem('user'));
  return user;
};

export const updateStore = (user) => {
  localStorage.setItem('user', JSON.stringify(user));
}